const HOST_LAN_IP_ENV = "HOST_LAN_IP";
const LOCAL_API_PORT = "8000";

function applyLanApiHost(config, lanIp) {
  const address = String(lanIp || "").trim();
  if (!address) {
    return config;
  }

  const host = `${address}:${LOCAL_API_PORT}`;
  return {
    ...config,
    apiHostName: `http://${host}/`,
    apiHostNameWithoutTrailingSlash: `http://${host}`,
    apiUrl: `http://${host}/:locale/api/`
  };
}

module.exports = {
  HOST_LAN_IP_ENV,
  LOCAL_API_PORT,
  applyLanApiHost
};
